module.exports = __webpack_public_path__ + "assets/img/ru-640b763c.png";